<template>
  <a-popover
    title="Selecciona etiquetas"
    :placement="placement"
    trigger="click"
  >
    <template slot="content">
      <list-checkboxes
        :data-source="dataSource"
        @onChange="(checked, key) => $emit('onCheck', checked, key)"
      >
        <template v-slot:description="slotsProps">
          <span
            >{{ slotsProps.checked }}/{{ slotsProps.total }} Actualmente
            seleccionados
          </span>
        </template>
        <template v-slot:title="slotsProps">
          <a-tag :color="slotsProps.data.color">{{
            slotsProps.data.title
          }}</a-tag>
        </template>
      </list-checkboxes>
    </template>
    <slot>
      <a-button> Escoger</a-button>
    </slot>
  </a-popover>
</template>

<script>
import ListCheckboxes from '@/app/shared/components/molecules/ListCheckboxes'
import { mapGetters } from 'vuex'

export default {
  name: 'PopoverTagsCheckboxes',
  props: {
    dataSource: {
      type: Array,
      required: true,
    },
    placement: {
      type: String,
      required: false,
      default: 'bottomRight',
    },
  },
  components: {
    ListCheckboxes,
  },
  computed: {
    ...mapGetters(['tags']),
  },
}
</script>

<style lang="sass" scoped></style>
